import { Analysis, PossibleRootCauseCategory } from '.';

export class ProteinsAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.protein.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_10000);
        } else if (this.ba.protein.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_10010);
        }

        if (this.ba.albumin.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_10020);
        } else if (this.ba.albumin.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_10030);
        }

        if (this.ba.globulin.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_10040);
        } else if (this.ba.globulin.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_10050);
        }

        if (this.ba.albuminGlobulinRatio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_10060);
        } else if (this.ba.albuminGlobulinRatio.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_10070);
        }
    }
}